import { Record as ImmutableRecord, List, Map } from "immutable";

import "../../sections/section/Section";
import "./references/reference/Reference";
import "./subscriptionTier/SubscriptionTier";
import "./tags/Tags";

import { SectionId } from "../../sections/section/Section";
import { ReferenceType } from "./references/reference/Reference";
import { SubscriptionTier } from "./subscriptionTier/SubscriptionTier";
import { Tags } from "./tags/Tags";

export type CourseId = string;

export type { SectionId, SubscriptionTier, Tags };

export type Authors = List<string>;

export type References = List<ReferenceType>;

export type AverageScorePercentiles = {
  p10: number;
  p20: number;
  p30: number;
  p40: number;
  p50: number;
  p60: number;
  p70: number;
  p80: number;
  p90: number;
};

export type CourseType = {
  id: CourseId | undefined;
  courseId: CourseId | undefined;
  name: string;
  description: string;
  authors: Authors;
  references: References;
  tags: Tags;
  headerImageURL: string | null;
  available: boolean;
  darkText: boolean;
  sectionIds: List<SectionId>;
  startingSectionId: SectionId | null | undefined;
  published: boolean | null;
  visibility: string | null;
  subscriptionTier: SubscriptionTier | null;
  relatedCourseIds: List<CourseId>;
  examQuestionsCount?: number;
  regions: List<string>;
  textToSpeechEnabled?: boolean;
  vocabularyEnabled?: boolean;
  averageScorePercentiles?: AverageScorePercentiles;
};

export type CourseFromServerTag = {
  id: string;
  value: string;
};

export type CourseFromServerType = {
  id: string;
  courseId: string;
  name: string;
  description: string;
  authors: Authors;
  references: References;
  tags: Record<string, Array<CourseFromServerTag>>;
  headerImageURL: string;
  available: boolean;
  darkText: boolean;
  sectionIds: Array<string>;
  startingSectionId: string | null | undefined;
  published: boolean;
  visibility: string;
  subscriptionTier: SubscriptionTier | null;
  relatedCourseIds: Array<CourseId>;
  regions: Array<string>;
  examQuestionsCount?: number;
  textToSpeechEnabled?: boolean;
  vocabularyEnabled?: boolean;
  averageScorePercentiles?: AverageScorePercentiles;
};

export type OptionalCourseType = Partial<CourseType>;

const defaultValues: CourseType = {
  id: undefined,
  courseId: undefined,
  name: "",
  description: "",
  authors: List(),
  references: List(),
  tags: Map<string, any>(),
  headerImageURL: null,
  available: false,
  darkText: true,
  sectionIds: List(),
  startingSectionId: null,
  published: null,
  visibility: null,
  subscriptionTier: null,
  relatedCourseIds: List(),
  regions: List(),
  examQuestionsCount: undefined,
  textToSpeechEnabled: undefined,
  vocabularyEnabled: undefined,
  averageScorePercentiles: undefined
};

export default class Course extends ImmutableRecord(defaultValues) {}
